import { css as _css } from "@emotion/core";
var _excluded = ["items", "selectedIndex", "updateSelectedIndex", "visible", "interactive"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import Thumbnails from '../thumbnails';
import * as models from '../../models';
import * as styles from './drawer.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Drawer = _ref => {
  var items = _ref.items,
    selectedIndex = _ref.selectedIndex,
    updateSelectedIndex = _ref.updateSelectedIndex,
    visible = _ref.visible,
    interactive = _ref.interactive,
    props = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX("div", _extends({
    css: /*#__PURE__*/_css([styles.drawer, interactive && styles.interactive, visible ? styles.show : styles.hide])
  }, props), ___EmotionJSX("div", {
    css: styles.info
  }, ___EmotionJSX("div", {
    css: styles.title
  }, items[selectedIndex].title), ___EmotionJSX("div", null, selectedIndex + 1, " / ", items.length)), ___EmotionJSX(Thumbnails, {
    css: styles.thumbnails,
    items: items,
    selectedIndex: selectedIndex,
    updateSelectedIndex: updateSelectedIndex
  }));
};
Drawer.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(models.item)),
  selectedIndex: PropTypes.number,
  updateSelectedIndex: PropTypes.func,
  visible: PropTypes.bool,
  interactive: PropTypes.bool
};
Drawer.defaultProps = {
  items: [],
  selectedIndex: 0,
  updateSelectedIndex: () => {},
  visible: false,
  interactive: false
};
export default Drawer;